import React from 'react';

import styled from 'styled-components';

import SkeletonLine from '~/techstyle-shared/react-components/src/SkeletonLine/SkeletonLine';

const SkeletonLoadersContainer = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

const SkeletonGroup = styled.div`
  display: flex;
  gap: 16px;
`;

const FilterBarSkeleton = () => {
  return (
    <SkeletonLoadersContainer>
      <SkeletonGroup>
        <SkeletonLine width={116} height={48} />
        <SkeletonLine width={577} height={48} />
      </SkeletonGroup>
      <SkeletonLine width={162} height={48} />
    </SkeletonLoadersContainer>
  );
};

export default FilterBarSkeleton;
